/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExportEstimateSchemaProfilesAlreadyExported } from './exportEstimateSchemaProfilesAlreadyExported';
import type { InsightsExportEstimateSchema } from './insightsExportEstimateSchema';

/**
 * Backend-calculated numbers the export wizard renders. The client
 * multiplies these as the user toggles format/contacts so the displayed
 * price always matches what `debit_export_credits` will charge:
 *
 *     export_credits  = Σ over selected formats
 *                       (profile_count − profiles_already_exported[format])
 *                       × credits_per_profile_per_format
 *     contact_credits = contacts_to_reveal × credits_per_contact_reveal
 *
 * `profiles_already_exported` is keyed by rendered artifact format ("csv" /
 * "pdf") because the wizard flips format client-side without refetching;
 * formats with nothing covered are omitted rather than sent as zero.
 *
 * This is an upper bound, not an equality: neither coverage count can
 * shrink between the quote and the charge (both kinds of marker are
 * write-once and never expire), so the workflow can charge less than was
 * quoted but never more.
 *
 * Insights exports are priced per format instead; see `insights`.
 */
export interface ExportEstimateSchema {
  profile_count: number;
  contacts_already_revealed: number;
  contacts_to_reveal: number;
  profiles_already_exported?: ExportEstimateSchemaProfilesAlreadyExported;
  credits_per_profile_per_format: number;
  credits_per_contact_reveal: number;
  insights?: InsightsExportEstimateSchema | null;
}
